import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../urls";
//axios
import axios from "../../utilies/axios";
//_________________________________________________


// GET =>  All NOTIFICATIONS SERVICE
export const getNotificationsService = createAsyncThunk(
  "general/getNotificationsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.notificationsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  All NOTIFICATIONS SERVICE
export const getNotificationsInfoService = createAsyncThunk(
  "general/getNotificationsInfoService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.notificationsInfoURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// DELETE =>  DELETE
export const deleteNotificationsService = createAsyncThunk(
  "general/deleteNotificationsService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.notificationsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);
//
// GET =>  All STATISTICS SERVICE
export const getStatisticsService = createAsyncThunk(
  "general/getStatisticsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.statisticsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// POST =>  CREATE USER SERVICE
export const createContactUservice = createAsyncThunk(
  "general/createUserService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.contactUsURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// POST =>  CREATE USER SERVICE
export const createNotificationService = createAsyncThunk(
  "general/createNotifictionService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.notificationsURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  GET ALL CONTACT USER SERVICE
export const getAllContactUSerService = createAsyncThunk(
  "general/getAllContactUSerService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.contactUsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  GET PRIVACY POLICY SERVICE
export const getPrivacyPolicyService = createAsyncThunk(
  "general/getPrivacyPolicyService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.privacyPolicyURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  GET DISCOUNT CODE SERVICE
export const getDiscountCouponsService = createAsyncThunk(
  "general/getDiscountCouponsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.discountCouponsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// POST =>  CREATE DISCOUNT CODE SERVICE
export const createDiscountCodeService = createAsyncThunk(
  "general/createDiscountCodeService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.discountCouponsURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// UPDATE =>  UPDATE PRODUCT SERVICE
export const updateDiscountCodeModal = createAsyncThunk(
  "general/updateCouponModal",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.discountCouponsURL}/${params?.id}`,
        params.formData,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// DELETE =>  DELETE DISOUNT CODE SERVICE
export const deleteDiscountCodeService = createAsyncThunk(
  "general/deleteDiscountCodeService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.delete(
        `${URLS.discountCouponsURL}/${params?.id}`,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  All ADVERTISMENT SERVICE
export const getAdvertisementsService = createAsyncThunk(
  "general/getAdvertisementsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.advertisementsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// POST =>  CREATE ADVERTISMENT SERVICE
export const createAdvertismentService = createAsyncThunk(
  "general/createAdvertismentService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.advertisementsURL, data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// UPDATE =>  UPDATE ADVE SERVICE
export const updateAdvertisementService = createAsyncThunk(
  "general/updateAdvertisementService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.advertisementsURL}/${params?.id}`,
        params.formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// DELETE =>  DELETE ADVERTISMENT SERVICE
export const deleteAdvertismentService = createAsyncThunk(
  "general/deleteAdvertismentService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.advertisementsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  All STORE INFO  SERVICE
export const getStoreInfoService = createAsyncThunk(
  "general/getStoreInfoService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.storeInfoURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  GET ALL GOVER  SERVICE
export const getAllgovernoratesService = createAsyncThunk(
  "general/getAllgovernoratesService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.governoratesURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// POST =>  CREATE Governorates SERVICE
export const createGovernoratesService = createAsyncThunk(
  "general/createGovernoratesService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.governoratesURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// DELETE =>  DELETE Governorates SERVICE
export const deleteGovernoratesService = createAsyncThunk(
  "general/deleteGovernoratesService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.governoratesURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// UPDATE =>  UPDATE Governorates SERVICE
export const updateGovernoratesService = createAsyncThunk(
  "general/updateGovernoratesService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.governoratesURL}/${params?.id}`,
        params?.data,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  GET AREA BY GOV
export const getAreaByGovService = createAsyncThunk(
  "general/getAreaByGovService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.areasURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// POST =>  CREATE AREA SERVICE
export const createAreaService = createAsyncThunk(
  "general/createGovernoratesService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.areasURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// DELETE =>  DELETE AREA SERVICE
export const deleteAreaService = createAsyncThunk(
  "general/deleteAreaService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.areasURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// UPDATE =>  UPDATE AREA SERVICE
export const updateAreaService = createAsyncThunk(
  "general/updateGovernoratesService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.areasURL}/${params?.id}`,
        params?.data,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// POST =>  CREATE Shipping  SERVICE
export const createShippingSettingService = createAsyncThunk(
  "general/createShippingSettingService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.shippingSettingsURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  GET Shipping  SERVICE
export const getShippingByIdService = createAsyncThunk(
  "general/getShippingByIdService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.shippingSettingsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  GET Shipping  SERVICE
export const getShippingService = createAsyncThunk(
  "general/getShippingService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(URLS.shippingSettingsURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// DELETE =>  DELETE SHIPPING SERVICE
export const deleteShippingService = createAsyncThunk(
  "general/deleteShippingService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.shippingSettingsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// UPDATE =>  UPDATE SHIPPING SERVICE
export const updateShippingService = createAsyncThunk(
  "general/updateShippingService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.shippingSettingsURL}/${params?.id}`,
        params?.data,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET =>  GET ALL GOVER  SERVICE
export const getCarBrandsService = createAsyncThunk(
  "general/getCarBrandsService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.carBrandsURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const createCarBrandService = createAsyncThunk(
  "general/createCarBrandService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.carBrandsURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const updateCarBrandService = createAsyncThunk(
  "general/updateCarBrandService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.carBrandsURL}/${params?.id}`,
        params.data,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);
// DELETE =>  DELETE VEHICLES SERVICE
export const deleteCarBrandService = createAsyncThunk(
  "general/deleteCarBrandService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.carBrandsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const getgearTypeService = createAsyncThunk(
  "general/getgearTypeService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.gearTypesURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const createGearTypeService = createAsyncThunk(
  "general/createGearTypeService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.gearTypesURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const updateGearTypeService = createAsyncThunk(
  "general/updateGearTypeService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.gearTypesURL}/${params?.id}`,
        params.data,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);
// DELETE =>  DELETE VEHICLES SERVICE
export const deleteGearTypeService = createAsyncThunk(
  "general/deleteGearTypeService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.gearTypesURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const getFuelTypesService = createAsyncThunk(
  "general/getFuelTypesService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.fuelTypesURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const createFuelTypesService = createAsyncThunk(
  "general/createFuelTypesService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.fuelTypesURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const updateFuelTypesService = createAsyncThunk(
  "general/updateFuelTypesService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.fuelTypesURL}/${params?.id}`,
        params.data,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);
// DELETE =>  DELETE FUEL SERVICE
export const deleteFuelTypesService = createAsyncThunk(
  "general/deleteFuelTypesService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.fuelTypesURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const getColorsService = createAsyncThunk(
  "general/getColorsService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.colorsURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const createColorsService = createAsyncThunk(
  "general/createColorsService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.colorsURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const updateColorsService = createAsyncThunk(
  "general/updateColorsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.colorsURL}/${params?.id}`,
        params.data,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);
// DELETE =>  DELETE FUEL SERVICE
export const deleteColorsService = createAsyncThunk(
  "general/deleteColorsService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.colorsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// MEDIA
export const getMediaService = createAsyncThunk(
  "general/getMediaService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.mediaURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const createMediaService = createAsyncThunk(
  "general/createMediaService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.mediaURL, data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const deleteMediaService = createAsyncThunk(
  "general/deleteMediaService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.mediaURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// CAR TYPE

export const getCarTypesService = createAsyncThunk(
  "general/getCarTypesService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.carTypesURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const createCarTypesService = createAsyncThunk(
  "general/createCarTypesService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.carTypesURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const updateCarTypesService = createAsyncThunk(
  "general/updateCarTypesService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.carTypesURL}/${params?.id}`,
        params.data,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);
// DELETE =>  DELETE FUEL SERVICE
export const deleteCarTypesService = createAsyncThunk(
  "general/deleteCarTypesService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.carTypesURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// ---------------------------- FAVORITE LISTINGS ----------------------------

// GET => All Favorite Listings (Admin)
export const getFavoriteListingsService = createAsyncThunk(
  "general/getFavoriteListingsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.favoriteListingsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// GET => Favorite Listing Details (Admin)
export const getFavoriteListingDetailService = createAsyncThunk(
  "general/getFavoriteListingDetailService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.favoriteListingsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// POST => Create Favorite Listing (Admin)
export const createFavoriteListingService = createAsyncThunk(
  "general/createFavoriteListingService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.favoriteListingsURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// DELETE => Delete Favorite Listing (Admin)
export const deleteFavoriteListingService = createAsyncThunk(
  "general/deleteFavoriteListingService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.favoriteListingsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);



// CAR MODELS

export const getCarModelsService = createAsyncThunk(
  "general/getCarModelsService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.carModelsURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const createCarModelsService = createAsyncThunk(
  "general/createCarModelsService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.carModelsURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const updateCarModelsService = createAsyncThunk(
  "general/updateCarModelsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.carModelsURL}/${params?.id}`,
        params.data,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

// IMPORTING COUNTRIES

export const getImportingCountriesService = createAsyncThunk(
  "general/getImportingCountriesService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.importingCountriesURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const createImportingCountriesService = createAsyncThunk(
  "general/createImportingCountriesService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.importingCountriesURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const updateImportingCountriesService = createAsyncThunk(
  "general/updateImportingCountriesService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.importingCountriesURL}/${params?.id}`,
        params.data,
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);
// DELETE =>  DELETE Importing SERVICE
export const deleteImportingCountriesService = createAsyncThunk(
  "general/deleteImportingCountriesService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.importingCountriesURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);